interface ResultCardProps {
    itemName: string;
    material: string;
    confidence: number;
    action: 'recycle' | 'trash' | 'special_dropoff';
    prepSteps: string[];
    uncertaintyReason?: string;
}

const actionColors = {
    recycle: 'bg-green-500',
    trash: 'bg-gray-500',
    special_dropoff: 'bg-amber-500'
};

const actionLabels = {
    recycle: 'Recycle',
    trash: 'Trash',
    special_dropoff: 'Special Drop-off'
};

export default function ResultCard({
    itemName,
    material,
    confidence,
    action,
    prepSteps,
    uncertaintyReason
}: ResultCardProps) {
    const confidencePercent = Math.round(confidence * 100);

    return (
        <div className="card mb-4">
            {/* Item Header */}
            <div className="flex items-center justify-between mb-4">
                <div>
                    <h2 className="text-xl font-bold text-gray-900">{itemName}</h2>
                    <p className="text-sm text-gray-500">{material}</p>
                </div>
                <div className={`${actionColors[action]} text-white px-4 py-2 rounded-full font-semibold text-sm`}>
                    {actionLabels[action]}
                </div>
            </div>

            {/* Confidence Bar */}
            <div className="mb-4">
                <div className="flex justify-between text-sm mb-1">
                    <span className="text-gray-600">Confidence</span>
                    <span className="font-semibold">{confidencePercent}%</span>
                </div>
                <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
                    <div
                        className={`h-full ${action === 'recycle' ? 'bg-green-500' : action === 'trash' ? 'bg-gray-500' : 'bg-amber-500'} rounded-full transition-all`}
                        style={{ width: `${confidencePercent}%` }}
                    />
                </div>
            </div>

            {/* Prep Steps */}
            {prepSteps.length > 0 && (
                <div className="mb-4">
                    <h3 className="font-semibold text-gray-900 mb-2">How to prepare:</h3>
                    <ol className="list-decimal list-inside space-y-1 text-sm text-gray-700">
                        {prepSteps.map((step, index) => (
                            <li key={index}>{step}</li>
                        ))}
                    </ol>
                </div>
            )}

            {/* Uncertainty Notice */}
            {uncertaintyReason && (
                <div className="bg-amber-50 border border-amber-200 rounded-lg p-3 text-sm text-amber-800">
                    <span className="font-semibold">Note: </span>{uncertaintyReason}
                </div>
            )}
        </div>
    );
}
